import { checkLocaleData } from 'src/utils/locale';
import { currentEnvironment, ENVIRONMENTS } from 'src/utils/runtime-config';

interface LocaleInfo {
  url?: string | null;
  translatedFrom?: string | null;
}

export enum LocaleInfoTypes {
  URL = 'url',
  TRANSLATED_FROM = 'translatedFrom',
}
interface Subdomains {
  [locale: string]: LocaleInfo;
}

const isProd = currentEnvironment === ENVIRONMENTS.PROD;

// Sorted according to the order of the locales in the language selector (header)
const subdomains: Subdomains = {
  'zh-CN': {
    url: isProd
      ? 'https://zh.virginatlantic.com/cn/zh'
      : 'https://stg-zh.virginatlantic.com/cn/zh',
  },
  'es-US': {
    translatedFrom: 'en-US',
  },
  'ko-KR': {
    translatedFrom: 'en-KR',
  },
};

export function getLocaleInfo(
  localeIdentifier: string,
  infoType: LocaleInfoTypes,
): string | null {
  const locale = checkLocaleData(localeIdentifier);
  if (!locale) {
    return null;
  }

  const subdomain = subdomains[locale];

  if (!subdomain) {
    return null;
  }

  const localeInfo = subdomain[infoType];
  return localeInfo || null;
}

export function getContentSourceLocale(localeIdentifier: string): string {
  return (
    getLocaleInfo(localeIdentifier, LocaleInfoTypes.TRANSLATED_FROM) ??
    localeIdentifier
  );
}
